import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

/**
 * DTO para combo de exportadores con órdenes de transporte
 */
export class ExportadorTransporteComboDto {
  @ApiProperty({
    description: 'ID del exportador',
    example: 66,
  })
  exportadorId!: number;

  @ApiProperty({
    description: 'Nombre del exportador',
    example: 'ACOGRAPES',
  })
  exportador!: string;
}

/**
 * DTO para combo de temporadas con órdenes de transporte
 */
export class TemporadaTransporteComboDto {
  @ApiProperty({
    description: 'ID de la temporada',
    example: 7,
  })
  seasonId!: number;

  @ApiProperty({
    description: 'Nombre de la temporada',
    example: '2024 - 2025',
  })
  seasonName!: string;

  @ApiPropertyOptional({
    description: 'Fecha inicio de la temporada',
    example: '2024-11-01',
  })
  seasonFrom?: string;

  @ApiPropertyOptional({
    description: 'Fecha fin de la temporada',
    example: '2025-10-31',
  })
  seasonTo?: string;
}

/**
 * DTO para combo de clientes con órdenes de transporte
 */
export class ClienteTransporteComboDto {
  @ApiProperty({
    description: 'ID del cliente',
    example: 376,
  })
  clienteId!: number;

  @ApiProperty({
    description: 'Nombre del cliente',
    example: 'MONFRUT',
  })
  cliente!: string;
}

/**
 * DTO para combo de naves con órdenes de transporte
 */
export class NaveTransporteComboDto {
  @ApiProperty({
    description: 'ID de la nave',
    example: 5034,
  })
  vesselId!: number;

  @ApiProperty({
    description: 'Nombre de la nave',
    example: 'WAN HAI 621',
  })
  vesselName!: string;
}

/**
 * DTO para combo de proveedores de transporte
 * @deprecated Use ExportadorTransporteComboDto en módulo Órdenes de Transporte
 */
export class ProveedorTransporteComboDto {
  @ApiProperty({
    description: 'ID del proveedor',
    example: 5,
  })
  providerId!: number;

  @ApiProperty({
    description: 'Nombre del proveedor',
    example: 'BELEN',
  })
  providerName!: string;
}
